const forceArray = a => (Array.isArray(a) ? a : a === undefined ? [] : [a])

/**
 * Unpack betradar specifiers string to object
 * @param {String} str
 * @returns {Object}
 */
const unpackSpecifiers = str => {
  if (typeof str !== 'string') {
    return null
  }

  if (str[0] === '{') {
    return JSON.parse(str)
  }

  const specifiers = {}

  if (str === '') {
    return specifiers
  }

  for (const specifierString of str.split('|')) {
    specifiers[specifierString.split('=')[0]] = specifierString.split('=')[1]
  }

  return specifiers
}

const preserveQuotes = obj =>
  Object.entries(obj).reduce((acc, [k, val]) => {
    if (typeof val === 'object' && val !== null && !(val instanceof Date)) {
      return { ...acc, [k]: preserveQuotes(val) }
    }

    return {
      ...acc,
      [k]: val === true || val === false || val === null || val === undefined ? `"${val}"` : val
    }
  }, {})

const convertResourceToFindMethod = resource => {
  const camelCaseResource = resource.replace(/[-_](.)/g, (match, char) => char.toUpperCase())
  const upperFirstResource = camelCaseResource.charAt(0).toUpperCase() + camelCaseResource.slice(1)

  return `find${upperFirstResource}`
}

module.exports = {
  forceArray,
  unpackSpecifiers,
  preserveQuotes,
  convertResourceToFindMethod
}
